export default __webpack_public_path__ + "static/media/title.5b9e4fce.png";